// extracted by mini-css-extract-plugin
export var content = "empty-courses-module--content--UmvCa";
export var title = "empty-courses-module--title--1vXrf";
export var wrapper = "empty-courses-module--wrapper--t7X9O";